module.exports = __webpack_public_path__ + "static/media/img_flow2@2x.a74db88c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_flow2@2x.png
// module id = 908
// module chunks = 0